import { render, staticRenderFns } from "./RealTimeTrans.vue?vue&type=template&id=118735ba&scoped=true"
import script from "./RealTimeTrans.vue?vue&type=script&lang=js"
export * from "./RealTimeTrans.vue?vue&type=script&lang=js"
import style0 from "./RealTimeTrans.vue?vue&type=style&index=0&id=118735ba&prod&lang=scss"
import style1 from "./RealTimeTrans.vue?vue&type=style&index=1&id=118735ba&prod&scoped=true&lang=scss"
import style2 from "./RealTimeTrans.vue?vue&type=style&index=2&id=118735ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118735ba",
  null
  
)

export default component.exports